import withProps from "recompose/withProps";
import compose from "recompose/compose";
import { withRouter } from "react-router";
import branchServerClient from "web/core/branchServerClient";

const EnhanceProductBreadcrumb = () =>
  compose(
    withRouter,
    branchServerClient(
      withProps((props) =>
        props.product
          ? [
              {
                path: props.product.path,
                name: props.product.name,
              },
            ]
          : []
      ),
      withProps((props) => ({
        breadcrumb: []
          .concat(
            props.location.state && props.location.state.breadcrumb
              ? props.location.state.breadcrumb
              : []
          )
          .concat([
            props.product && {
              path: props.product.path,
              name: props.product.name,
            },
          ]),
      }))
    )
  );

export default EnhanceProductBreadcrumb;
